import {
  GET_PAGES,
  // GET_BLOG,
  GET_APP,
  VIEW_NAV,
  VIEW_BODY,
  VIEW_TYPES,
  VIEW_SHOWMODAL,
  VIEW_MODAL,
  VIEW_MENU,
  IS_MOBILE
} from './mutation-types'

const mutations = {
  [GET_PAGES] (state, data) {
    state.pages = data
    state.loading = false
  },
  // [GET_BLOG] (state, data) {
  //   state.blog = data
  //   state.blog.current_page = {}
  //   state.blog.current_page.number = 1
  //   state.loading = false
  // },
  [GET_APP] (state, data) {
    state.app = data
  },
  [VIEW_NAV] (state, data) {
    state.nav = data
  },
  [VIEW_BODY] (state, data) {
    state.body = data
  },
  [VIEW_TYPES] (state, data) {
    state.types = data
  },
  [VIEW_SHOWMODAL] (state, data) {
    state.showModal = data
  },
  [VIEW_MODAL] (state, data) {
    state.modal = data
  },
  [VIEW_MENU] (state, data) {
    state.menu = data
  },
  [IS_MOBILE] (state, data) {
    state.mobile = data
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/shared/store/mutations.js